import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Grid, Paper } from '@mui/material';
import Titlebar from '../../TitleBar';
import { TableBody2 } from '.';
import { Pagination, SearchTable, TableHeader } from '../../TableTemplate/index';
import Table from '@mui/material/Table';
import TableContainer from '@mui/material/TableContainer';
import { applyFilter, emptyRows, getComparator, extractDate } from '../../../Utils/table';
import { attendanceMenu } from '../../TitleList';
import { fetchEmpAttendanceReg } from '../../../Store/PHPSlice/Employee';
import { selectEmpAttendanceReg } from '../../Selectors/Master/MasterSelectors';


const EmpAttendanceReg = () => {
    const dispatch = useDispatch();
    const getEmployee = useSelector(selectEmpAttendanceReg);
    const [order, setOrder] = useState('asc');
    const [orderBy, setOrderBy] = useState('empId');
    const [selected, setSelected] = useState([]);
    const [filterName, setFilterName] = useState('null');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [recordsPerPage, setRecordsPerPage] = useState(10);
    const [searchQuery, setSearchQuery] = useState("");
    const [firstIndex, setFirstIndex] = useState(0);
    const [lastIndex, setLastIndex] = useState(0);

    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [pageRange, setPageRange] = useState([0, 10]); // Initial range [0, 10]
    const [searchTerm, setSearchTerm] = useState('');

    useEffect(() => {
        dispatch(fetchEmpAttendanceReg());
    }, [dispatch]);

    if (!getEmployee) {
        return <h1>Loading...</h1>;
    }


    const compData = Array.isArray(getEmployee.data) ? getEmployee?.data?.map((item, index) => (
        {
            srno: item.ID,
            entrydt: item.entrydt,
            empNm: item.empNm,
            empId: item.empId,
            punchId: item.punchId,
            fromdt: item.fromdt,
            todt: item.todt,
            totdays: item.totdays,
            present_days: item.present_days,
            leave_days: item.leave_days,
            perHr_pay: item.perHr_pay,
            totwork_hr: item.totwork_hr,
            extra_hr: item.extra_hr,
            payamt: item.payamt,
            serialNumber: index + 1,
        }
    )) : [];



    const handleSort = (event, id) => {
        const isAsc = orderBy === id && order === 'asc';
        if (id !== '') {
            setOrder(isAsc ? 'desc' : 'asc');
            setOrderBy(id);
        }
    };
    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            const newSelecteds = compData.map((n) => n.name);
            setSelected(newSelecteds);
            return;
        }
        setSelected([]);
    };

    const handleClick = (event, name) => {
        const selectedIndex = selected.indexOf(name);
        let newSelected = [];
        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, name);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1)
            );
        }
        setSelected(newSelected);
    };

    const handleChangeCPage = (n) => {
        setCurrentPage(n);
    };
    const handlePrevPage = () => {
        if (currentPage !== firstIndex) {
            setCurrentPage(currentPage - 1);
        }
    };

    const handleNextpage = () => {
        if (currentPage !== lastIndex) {
            setCurrentPage(currentPage + 1);
        }
    };

    const handleRecordsPerPageChange = (event) => {
        setRecordsPerPage(parseInt(event.target.value, 10)); // Parse selected value to integer
        setCurrentPage(0); // Reset current page when records per page changes
    };

    const totalCount = compData.length;
    const npages = Math.ceil(totalCount / recordsPerPage);
    const numbers = [...Array(npages + 1).keys()].slice(1);
    const renderPaginationButtons = () => {
        let start = Math.max(0, currentPage - 5);
        let end = Math.min(npages, start + 9);

        if (end - start < 9) {
            start = Math.max(1, end - 9);
        }

        return numbers.slice(start - 1, end).map((n) => (

            <button key={n} className={`page-link ${currentPage === n - 1 ? 'active' : ''}`} onClick={() => handleChangeCPage(n - 1)}>{n}</button>
        ));
    };

    const handleFilterByName = (event) => {
        setPage(0);
        let value = event.target.value.trim();
        setFilterName(event.target.value);


    };
    // const dataFiltered = applyFilter({
    //     inputData: compData,
    //     comparator: getComparator(order, orderBy),

    // });
    // const notFound = !dataFiltered.length;

    const handleSearchChange = (event) => {
        setSearchTerm(event.target.value);
        setCurrentPage(1); // Reset to first page on search
    };

    // const filteredData = (Array.isArray(compData) ? compData : []).filter(item =>
    //     item?.empNm?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    //     item?.punchId?.toLowerCase().includes(searchTerm.toLowerCase())
    // );

    const filteredData = (Array.isArray(compData) ? compData : []).filter((item) =>
    Object.values(item).some((value) =>
        String(value).toLowerCase().includes(searchTerm.toLowerCase())
    )
);


    const dataFiltered = applyFilter({
        inputData: filteredData,
        comparator: getComparator(order, orderBy),

    });

    const totalPages = Math.ceil(dataFiltered.length / itemsPerPage);
    const displayedData = dataFiltered.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);


    const pageNumbers = Array.from({ length: totalPages }, (_, index) => index + 1);
    const visiblePageNumbers = pageNumbers.slice(pageRange[0], pageRange[1]);

    const handleNextPageRange = () => {
        setPageRange([pageRange[0] + 5, pageRange[1] + 5]);
    };

    const handlePreviousPageRange = () => {
        setPageRange([pageRange[0] - 5, pageRange[1] - 5]);
    };

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const handleItemsPerPageChange = (event) => {
        setItemsPerPage(Number(event.target.value));
        setCurrentPage(1); // Reset to first page on change
    };

    return (
        <>
            <Titlebar data={attendanceMenu} />

            <div style={{ margin: '1% 0.5%' }}>
                <h2>Employee Attendance Register</h2>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '3vh', margin: '0' }}>

                            <SearchTable
                                handleItemsPerPageChange={handleItemsPerPageChange}
                                searchTerm={searchTerm}
                                handleSearchChange={handleSearchChange}
                                totalItems={filteredData?.length}
                            />

                            <TableContainer style={{ marginTop: '2%' }}>
                                <Table>
                                    <TableHeader
                                        headCells={
                                            [
                                                { id: 'srno', label: 'SrNo' },
                                                { id: 'entrydt', label: 'Entry Date' },
                                                { id: 'empNm', label: 'Employee Name' },
                                                { id: 'punchId', label: 'Punching Id' },
                                                { id: 'fromdt', label: 'From Date' },
                                                { id: 'todt', label: 'To Date' },
                                                { id: 'totdays', label: 'Total Days' },
                                                { id: 'present_days', label: 'Presend Days' },
                                                { id: 'leave_days', label: 'Leave Days' },
                                                { id: 'perHr_pay', label: 'Per Hour Pay' },
                                                { id: 'totwork_hr', label: 'Total Work Hours' },
                                                { id: 'extra_hr', label: 'Total Extra Work Hours' },
                                                { id: 'payamt', label: 'Payable Amount' },
                                                { id: '', label: 'View' },
                                                // { id: '', label: 'Edit' },
                                                { id: '', label: 'Delete' }
                                            ]
                                        }
                                        order={order}
                                        orderBy={orderBy}
                                        onRequestSort={handleSort}
                                        numSelected={selected.length}
                                        rowCount={compData.length}
                                        onSelectAllClick={handleSelectAllClick}
                                    />
                                    <tbody>


                                        {displayedData?.map((row) => (
                                            <TableBody2
                                                key={row.srno}
                                                id={row.srno}
                                                serialNumber={row.serialNumber}
                                                entrydt={row.entrydt}
                                                empId={row.empId}
                                                empNm={row.empNm}
                                                punchId={row.punchId}
                                                fromdt={row.fromdt}
                                                todt={row.todt}
                                                totdays={row.totdays}
                                                present_days={row.present_days}
                                                leave_days={row.leave_days}
                                                perHr_pay={row.perHr_pay}
                                                totwork_hr={row.totwork_hr}
                                                payamt={row.payamt}
                                                extra_hr={row.extra_hr}
                                                selected={selected.indexOf(row.name) !== -1}
                                                handleClick={(event) => handleClick(event, row.name)}
                                            />
                                        ))}
                                    </tbody>
                                </Table>
                            </TableContainer>


                            <Pagination
                                currentPage={currentPage}
                                handlePageChange={handlePageChange}
                                handlePreviousPageRange={handlePreviousPageRange}
                                visiblePageNumbers={visiblePageNumbers}
                                pageNumber={pageNumbers}
                                pageRange={pageRange}
                                totalPages={totalPages}
                                handleNextPageRange={handleNextPageRange}
                            />
                        </Paper>
                    </Grid>
                </Grid>
            </div>

        </>
    );
}

export default EmpAttendanceReg;
